import { render, staticRenderFns } from "./formCommunicationConfig.vue?vue&type=template&id=2e008fbc&"
import script from "./formCommunicationConfig.vue?vue&type=script&lang=js&"
export * from "./formCommunicationConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports